/**
 * 应用工具类
 */
import store from '@/store/index'
import { MapLoader } from '@/utils/map'
import { WeiXinLoader } from '@/utils/weixin'
import { isWXEnv, isDDEnv, isGDTEnv } from './env'
import { registerGlobalDD } from '@/ddUtils/init'

/* 应用初始化前行为 */
export const beforeInit = () => {
  return loadDict().then(() => {
    if (isWXEnv()) {
      // 加载微信
      WeiXinLoader()
    } else {
      if (isDDEnv() || isGDTEnv()) {
        registerGlobalDD()
      }
      // 加载地图
      MapLoader()
    }
  })
}

/**
 * 加载字典
 */
const loadDict = () => {
  return store.dispatch('loadDict')
}



// WEBPACK FOOTER //
// ./src/utils/app.js